import _ from 'lodash'
import SearchView from 'scoreboard/components/search-view'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'

const SinglePrincipalChooser = SearchView.extend({

	events: {
		'click': 'show',
		'change': 'change'
	},

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.selected an option to display pre-selected in
	 * the dropdown. Note you have to pass in a full object with ID and label.
	 * We can't use just an ID because most endpoints search based on text the
	 * user typed in, not specific IDs
	 */
	initialize: function(options = {}) {
		SearchView.prototype.initialize.apply(this, arguments)
		this.url = _.result(this.options, 'url') ?? 'api/admin/users'

		this._options = []

		if (this.options.selected) {
			let selected = _.extend({},
				this.options.selected, { selected: true })
			this._options.push(selected)
		}
	},

	change() {
		if (!this.$('select').val()) {
			// They cleared the value, reset the options
			this._options = []
			this.render()
		}
	},

	draw(principals) {
		clearTimeout(this.loadingTimeout)
		this.clearLoadingDots()
		this._options = principals
		this.renderSelect()
	},

	renderSelect() {
		selects.filtering(this.$('select'), {
			placeholder: _.get(this.options, 'placeholder', i18n.get('common.startTyping')),
			accessors: {
				'value': 'id'
			},
			options: this._options,
			onSearch: value => {
				this.search(value)
				this.createLoadingDots()
			}
		})
	},

	render() {
		this.renderSelect()
		return this
	},

	show() {
		if (this.shown) {
			return
		} else {
			this.shown = true
		}

		this.search()
	}

})

export default SinglePrincipalChooser

SinglePrincipalChooser.__filename__ = 'components/single-principal-chooser.js'
